@if (navbarData.hasValue()) {
    <nav
        class="z-[100] fixed lg:place-items-center lg:grid grid-cols-[max-content_1fr_max-content] mx-auto p-6 w-full"
        [style]="{
            color: slugService.isHome() ? 'white' : 'black',
        }"
        #navbar
    >
        <!-- logo + hamburger -->
        <div class="flex justify-between items-center ~gap-2/4">
            <a
                class="flex flex-shrink-0 items-center hover:scale-105 transition-transform cursor-pointer"
                [routerLink]="['/', languageService.getLanguageCode, 'hof']"
                aria-label="zehentmoar"
                (click)="umami.track('navbar-logo-click')"
            >
                <img
                    class="w-auto ~h-16/24"
                    src="{{ navbarData.value().data.logo.url }}"
                    alt="zehentmoar logo"
                    id="logo"
                />
            </a>
            <div class="lg:hidden">
                <a
                    [routerLink]="[
                        '/',
                        languageService.getLanguageCode,
                        'hof',
                        'shop',
                    ]"
                    queryParamsHandling="preserve"
                    class="z-10 font-semibold"
                    ><app-button
                        (click)="umami.track('navbar-shop-button-click')"
                        >{{ "footer.toShop" | translate }}</app-button
                    ></a
                >
            </div>
            <app-cart-icon
                id="cart-item-amount-mobile"
                class="lg:hidden"
            ></app-cart-icon>
            <div class="lg:hidden">
                <button
                    type="button"
                    class="hs-collapse-toggle relative flex justify-center items-center gap-x-2 bg-white hover:bg-gray-50 focus:bg-gray-300 disabled:opacity-50 shadow-2xs border border-gray-700 rounded-lg focus:outline-hidden size-9 text-gray-800 disabled:pointer-events-none"
                    id="hs-navbar-example-collapse"
                    aria-expanded="false"
                    aria-controls="hs-navbar-example"
                    aria-label="Toggle navigation"
                    data-hs-collapse="#hs-navbar-example"
                >
                    <svg
                        class="hs-collapse-open:hidden size-4 shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="3" x2="21" y1="6" y2="6" />
                        <line x1="3" x2="21" y1="12" y2="12" />
                        <line x1="3" x2="21" y1="18" y2="18" />
                    </svg>
                    <svg
                        class="hidden hs-collapse-open:block size-4 shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                    <span class="sr-only">Toggle navigation</span>
                </button>
            </div>
        </div>
        <!-- items -->
        <app-navbar-items
            [navbarItems]="navbarData.value().data.navbarItems"
            page="hof"
        ></app-navbar-items>

        <!-- language + social media + cart -->
        <div
            class="hidden lg:flex justify-center justify-self-end items-center gap-4"
        >
            <app-social-media-links
                class="flex"
                [ngClass]="{
                    'fill-white': slugService.isHome(),
                }"
                id="social-media-links"
            ></app-social-media-links>
            <a
                [routerLink]="[
                    '/',
                    languageService.getLanguageCode,
                    'hof',
                    'kontakt',
                ]"
            >
                <button
                    class="bg-white hover:bg-gray-200 shadow-[0_0_2px_2px_rgba(0,0,0,.1)] py-2 border border-gray-200 rounded-full font-medium text-primary text-base hover:scale-105 transition-[colors,transform] ~px-5/6"
                >
                    {{ "contactYard.contact" | translate }}
                </button>
            </a>
            <a
                [routerLink]="[
                    '/',
                    languageService.getLanguageCode,
                    'hof',
                    'shop',
                ]"
                queryParamsHandling="preserve"
                ><app-button
                    size="small"
                    (click)="umami.track('navbar-shop-button-click')"
                >
                    {{ "footer.toShop" | translate }}
                </app-button></a
            >
            <app-cart-icon id="cart-item-amount-desktop"></app-cart-icon>
        </div>
        @if (cartService.showCart()) {
            <app-cart
                class="top-8 right-0 absolute"
                (close)="cartService.toggleCart()"
            ></app-cart>
        }
    </nav>
}
